const STORAGE_KEY = "zephix-dp-theme";

export type DesignPartnerTheme = "light" | "dark";

export function readDesignPartnerTheme(): DesignPartnerTheme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    /* ignore */
  }
  return "light";
}

export function writeDesignPartnerTheme(theme: DesignPartnerTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function toggleDesignPartnerTheme(current: DesignPartnerTheme): DesignPartnerTheme {
  return current === "dark" ? "light" : "dark";
}
